webpackJsonp([11],{

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);

var _require = __webpack_require__(65),
    amplify = _require.amplify;

$(function () {
	$(".header-idioma a").click(function (event) {
		event.preventDefault();
		if ($(this).closest('li').hasClass('active')) {
			event.stopPropagation();
			return false;
		}
		var locale = $(this).data('locale');
		var localeForm = $('#localeForm');
		if (!localeForm.length) {
			$('body').append('<form id="localeForm"><input type="hidden" name="locale" value=""></form>');
		}
		amplify.publish('locale.before-change', { locale: locale });
		$('#localeForm input[name=locale]').val(locale);
		$('#localeForm').submit();
	});
});

/***/ })

},[377]);


// WEBPACK FOOTER //
// aemps/header.e9d75ca0aa34efa717a3.js